import {createBrowserRouter, type LoaderFunctionArgs} from 'react-router-dom';
import {AppLayout, NotFound, RouteError} from './components';
import {capabilityId, loadJson} from './data';
import type {CapabilityIndexData, FactionIndexItem, FactionPageData, LeafPageData, Manifest, MatrixData, MechanicsData, PairReport, PairSummary, ParentPageData} from './types';
import {CapabilitiesIndexPage, FactionIndexPage, FactionPage, HomePage, LeafCapabilityPage, MatrixPage, MechanicsPage, MethodologyPage, PairIndexPage, PairPage, ParentCapabilityPage} from './pages';

const required = (value: string | undefined) => {
  if (!value) throw new Response('Not found', {status: 404});
  return value;
};

export const routeObjects = [{
  path: '/',
  element: <AppLayout />,
  errorElement: <RouteError />,
  children: [
    {index: true, loader: () => loadJson<Manifest>('manifest.json'), element: <HomePage />},
    {path: 'capabilities', loader: () => loadJson<CapabilityIndexData>('capabilities/index.json'), element: <CapabilitiesIndexPage />},
    {path: 'capabilities/:parentId', loader: ({params}: LoaderFunctionArgs) => loadJson<ParentPageData>(`capabilities/parents/${capabilityId(required(params.parentId))}.json`), element: <ParentCapabilityPage />},
    {path: 'capabilities/:parentId/:leafId', loader: async ({params}: LoaderFunctionArgs) => {
      const data = await loadJson<LeafPageData>(`capabilities/leaves/${capabilityId(required(params.leafId))}.json`);
      if (data.leaf.parent_id !== capabilityId(required(params.parentId))) throw new Response('Not found', {status: 404});
      return data;
    }, element: <LeafCapabilityPage />},
    {path: 'factions', loader: () => loadJson<FactionIndexItem[]>('factions/index.json'), element: <FactionIndexPage />},
    {path: 'factions/:factionId', loader: ({params}: LoaderFunctionArgs) => loadJson<FactionPageData>(`factions/${required(params.factionId)}.json`), element: <FactionPage />},
    {path: 'pairs', loader: () => loadJson<PairSummary[]>('pairs/index.json'), element: <PairIndexPage />},
    {path: 'pairs/:pairId', loader: ({params}: LoaderFunctionArgs) => loadJson<PairReport>(`pairs/reports/${required(params.pairId)}.json`), element: <PairPage />},
    {path: 'matrix', loader: () => loadJson<MatrixData>('pairs/matrix.json'), element: <MatrixPage />},
    {path: 'mechanics', loader: () => loadJson<MechanicsData>('mechanics.json'), element: <MechanicsPage />},
    {path: 'methodology', element: <MethodologyPage />},
    {path: '*', element: <NotFound />},
  ],
}];

export const router = createBrowserRouter(routeObjects);
